
import SelectButton from '@/components/new/buttons/SelectButton.vue'
import CustomButton from '@/components/new/buttons/CustomButton.vue'
import RangePicker from '@/components/new/scheduler/RangePicker.vue'
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'

@Component({
    components: {
        SelectButton,
        CustomButton,
        RangePicker
    },
})
export default class TopItemPicker extends Vue {
    // @Prop({ type: String, default: "Days" }) readonly rangeBy: string = 'Days';
    selectedOption: string = 'Days'

    @Prop({ type: Number, default: null }) readonly weekStart!: number;
    @Prop({ type: Number, default: null }) readonly weekEnd!: number;
    @Prop({ type: Number, default: null }) readonly currentYear!: number;
    @Prop({ type: Number, default: null }) readonly currentWeekNumber!: number;
    @Prop({ type: Number, default: null }) readonly quater!: number;
    @Prop({ type: String, default: null }) readonly currentMonth!: string;
    @Prop({ type: String, default: null }) readonly nextMonth!: string;
    @Prop({ type: String, default: null }) readonly defaultSelectedOption!: string;
    @Prop({ type: Boolean, default: null }) readonly isCollapsed!: boolean;
    @Prop({ type: String, default: "Select" }) readonly placeHolderText!: string;


    title: string = `Week ${this.currentWeekNumber}`;
    options: any = [
        'Days',
        'Weeks',
        'Months',
    ];

    optionChange(value: string) {
        this.$emit('optionChange', value)
    }

    //set title according to option

    today() {
        this.$emit('today')
    }

    //get quater number of the year
    next() {
        this.$emit('next')
    }

    prev() {
        this.$emit('prev')
    }

    collapseAll() {
        this.$emit('collapseAll')
    }

    get collapseTitle() {
        return !this.isCollapsed ? 'Expand all' : 'Collapse all'
    }

}
